export enum ReportLayoutTypeEnum {
  CHART = 'CHART',
  LIST = 'LIST',
  PARAGRAPH = 'PARAGRAPH',
  TABLE = 'TABLE',
}
